function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { forwardRef, useMemo, useRef } from "react";
import useComposedRef from "../../hooks/useComposedRef";
import { Transition } from "../Transition";
import { resolveIds } from "../../utils/resolveIds";
var Collapse = forwardRef(function(_param, ref) {
    var children = _param.children, easing = _param.easing, duration = _param.duration, transitions = _param.transitions, onEnter = _param.onEnter, onEntering = _param.onEntering, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onExited = _param.onExited, _orientation = _param.orientation, orientation = _orientation === void 0 ? 'vertical' : _orientation, isCollapseDisabled = _param.isCollapseDisabled, wrapperStyles = _param.wrapperStyles, testID = _param.testID, props = _objectWithoutProperties(_param, [
        "children",
        "easing",
        "duration",
        "transitions",
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "orientation",
        "isCollapseDisabled",
        "wrapperStyles",
        "testID"
    ]);
    var collapseRef = useRef(null);
    var combinedRef = useComposedRef(collapseRef, ref);
    var wrapperRef = useRef(null);
    var collapseAttribute = orientation === 'horizontal' ? 'width' : 'height';
    var getElementSize = function() {
        var _$ref, _$ref1;
        var size = orientation === 'horizontal' ? (_$ref = wrapperRef.current) === null || _$ref === void 0 ? void 0 : _$ref.scrollWidth : (_$ref1 = wrapperRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.scrollHeight;
        return "".concat(size, "px");
    };
    var handleEnter = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (collapseRef.current) {
            collapseRef.current.style[collapseAttribute] = isCollapseDisabled ? '' : '0px';
        }
        onEnter === null || onEnter === void 0 ? void 0 : onEnter.apply(void 0, _toConsumableArray(args));
    };
    var handleEntering = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (collapseRef.current) {
            collapseRef.current.style[collapseAttribute] = isCollapseDisabled ? '' : getElementSize();
        }
        onEntering === null || onEntering === void 0 ? void 0 : onEntering.apply(void 0, _toConsumableArray(args));
    };
    var handleEntered = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (collapseRef.current) {
            collapseRef.current.style[collapseAttribute] = isCollapseDisabled ? '' : 'auto';
        }
        onEntered === null || onEntered === void 0 ? void 0 : onEntered.apply(void 0, _toConsumableArray(args));
    };
    var handleExit = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (collapseRef.current) {
            collapseRef.current.style[collapseAttribute] = isCollapseDisabled ? '' : getElementSize();
            collapseRef.current.scrollTop;
        }
        onExit === null || onExit === void 0 ? void 0 : onExit.apply(void 0, _toConsumableArray(args));
    };
    var handleExiting = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (collapseRef.current) {
            collapseRef.current.style[collapseAttribute] = isCollapseDisabled ? '' : '0px';
        }
        onExiting === null || onExiting === void 0 ? void 0 : onExiting.apply(void 0, _toConsumableArray(args));
    };
    var handleExited = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        onExited === null || onExited === void 0 ? void 0 : onExited.apply(void 0, _toConsumableArray(args));
    };
    var combinedTransitions = useMemo(function() {
        var collapseTransition = {
            transitionProperty: collapseAttribute,
            entering: {
                overflow: 'hidden'
            },
            exiting: {
                overflow: 'hidden'
            },
            entered: {
                overflow: 'visible'
            },
            exited: _defineProperty({}, collapseAttribute, isCollapseDisabled ? undefined : '0px')
        };
        if (isCollapseDisabled) {
            return transitions;
        }
        if (typeof transitions === 'undefined') {
            return collapseTransition;
        }
        if (!Array.isArray(transitions)) {
            return [
                transitions,
                collapseTransition
            ];
        }
        return _toConsumableArray(transitions).concat([
            collapseTransition
        ]);
    }, [
        transitions,
        collapseAttribute,
        isCollapseDisabled
    ]);
    return _jsx(Transition, _objectSpread({}, props, {
        ref: combinedRef,
        transitions: combinedTransitions,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        onExited: handleExited,
        duration: duration,
        easing: easing,
        testID: testID,
        children: _jsx("div", _objectSpread({
            ref: wrapperRef,
            css: wrapperStyles
        }, resolveIds(undefined, testID, 'collapse-wrapper'), {
            children: children
        }))
    }));
});
export { Collapse };
export default Collapse;
